module.exports = __webpack_public_path__ + "static/media/dark-theme-alerts-count.5eaaea77.svg";